import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './text-input.html',
  styleUrl: './text-input.css'
})
export class TextInput {
  @Input() label: string = '';
  @Input() labelStyle: 'uppercase' | 'normal' = 'uppercase';
  @Input() placeholder: string = '';
  @Input() type: 'text' | 'email' | 'password' | 'textarea' = 'text';
  @Input() value: string = '';
  @Input() errorMessage: string = '';
  @Input() maxLength: number | null = null;
  @Input() rows: number = 4;
  @Output() valueChange = new EventEmitter<string>();

  showPassword: boolean = false;

  onInput(newValue: string) {
    if (this.maxLength) {
      newValue = newValue.slice(0, this.maxLength);
    }
    this.value = newValue;
    this.valueChange.emit(newValue);
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  get inputType(): string {
    if (this.type !== 'password') return this.type;
    return this.showPassword ? 'text' : 'password';
  }
}